import { useMutation } from '@tanstack/react-query'
import { useAxios } from '../../core/AxiosContext'
import { useGlobalDispatch } from '../../core/GlobalContext'
import { BANNER_DUCK } from '../../core/actions'
import { fetchFinancierAction } from '../../routes/financier/FinancierDuck'

const baseApiPath = '/api/v3/financiers'

export const useSendMigrationOTP = ({ id }) => {
  const { authAxios } = useAxios()
  return useMutation({
    mutationFn: async () => await authAxios.post(`${baseApiPath}/${id}/send_migration_otp`).then(res => res.data),
  })
}

export const useResendMigrationOTP = ({ id, otp_verification_id }) => {
  const { authAxios } = useAxios()
  return useMutation({
    mutationFn: async () =>
      await authAxios.put(`${baseApiPath}/${id}/resend_migration_otp`, { otp_verification_id }).then(res => res.data),
  })
}

export const useVerifyMigrationOTP = ({ id, otp_verification_id }) => {
  const { authAxios } = useAxios()
  const { financierDispatch, bannerDispatch } = useGlobalDispatch()
  return useMutation({
    mutationFn: async ({ otp_to_be_verified }) =>
      await authAxios
        .put(`${baseApiPath}/${id}/verify_migration_otp`, { otp_to_be_verified, otp_verification_id })
        .then(res => res.data),
    onSuccess: () => {
      bannerDispatch({ type: BANNER_DUCK.HIDE_BANNER, payload: 'blockInteraction' })
      // Refetch financier data after accepting the terms to update state so that resolution banner will show up
      fetchFinancierAction()(authAxios, financierDispatch)
    },
  })
}
